import React, { useRef, useState, useEffect } from 'react';
import {
  string, number, node, objectOf, any, func,
} from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';

import {
  Container,
  ContainerInside,
} from './styles';

const DndVerticalSortable = (props) => {
  const ref = useRef(null);

  const {
    accept,
    children,
    index,
    element,
    onEnd,
    onMove,
  } = props;

  const [isMoving, setIsMoving] = useState(false);
  const [isOverHalf, setIsOverHalf] = useState(undefined);

  const [{ handlerId, didDrop, isOver }, drop] = useDrop({
    accept,
    collect: (monitor) => ({
      handlerId: monitor.getHandlerId(),
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
      didDrop: !!monitor.didDrop(),
    }),
    canDrop: (item) => item.type === accept,
    drop: (item) => {
      setIsOverHalf(undefined);

      if (isOverHalf === true && item.index >= index + 1) {
        if (item.index === index + 1) {
          return { index };
        }
        onMove(item, index + 1);
        return { index };
      }

      if (isOverHalf === false && item.index <= index - 1) {
        if (item.index === index - 1) {
          return { index };
        }
        onMove(item, index - 1);
        return { index };
      }

      onMove(item, index);
      return { index };
    },
    hover: (item, monitor) => {
      if (!ref.current) return;

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.height) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      setIsOverHalf(clientOffset.y > hoverBoundingRect.top + hoverMiddleY);
      setIsMoving(true);
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: element.type,
    item: {
      ...element,
      index,
    },
    end: (item, monitor) => {
      setIsMoving(false);

      const dropResult = monitor.getDropResult();

      if (item && !monitor.didDrop()) {
        onEnd(item, false);
      } else if (item && dropResult) {
        onEnd(item, true);
      }
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  useEffect(() => {
    if (!didDrop) {
      setIsMoving(false);
    }
  }, [didDrop]);

  drag(drop(ref));

  const addPaddingTop = (isOverHalf === false && isMoving && isOver);
  const addPaddingBottom = (isOverHalf === true && isMoving && isOver);

  return (
    <Container
      data-handler-id={handlerId}
      addPaddingTop={addPaddingTop}
      addPaddingBottom={addPaddingBottom}
      isDragging={isDragging}
      ref={ref}
    >
      <ContainerInside>
        {children}
      </ContainerInside>
    </Container>
  );
};

DndVerticalSortable.propTypes = {
  accept: string.isRequired,
  children: node.isRequired,
  index: number.isRequired,
  element: objectOf(any).isRequired,
  onMove: func.isRequired,
  onEnd: func,
};

DndVerticalSortable.defaultProps = {
  onEnd: () => { },
};

export default DndVerticalSortable;
